import { IMAGEPATH } from '../../constants/imagePath';
import { KR } from '../../constants/localizations';
import styles from '../../styles/products.module.css';

export default function ProductDeliveryRobotCardSeu() {
    return (
        <div className={styles.container}>
            <div className={styles.robotDeliveryBS}>
                <div className={styles.imgBox}>
                    <img src={IMAGEPATH.seu} srcSet={IMAGEPATH.seuWebp} alt="ar247_robot" loading="lazy" />
                </div>
                <div className={styles.info}>
                    <h3>{KR.label_products_seuseuro}</h3>
                    <div>
                        <span className={styles.label}>{KR.label_products_detail_size}</span>
                        <span>600(w)x817(d)x1,012(h)mm</span>
                    </div>
                    <div>
                        <span className={styles.label}>{KR.label_products_detail_box}</span>
                        <span>600mm x 600m x 458mm</span>
                    </div>
                    <div>
                        <span className={styles.label}>{KR.label_products_detail_box_weight}</span>
                        <span>60Kg</span>
                    </div>
                    <div>
                        <span className={styles.label}>{KR.label_products_detail_speed}</span>
                        <span>7km</span>
                    </div>
                    <div>
                        <span className={styles.label}>{KR.label_products_detail_sensor}</span>
                        <span>라이다·카메라·초음파·LED</span>
                    </div>
                </div>
            </div >
            <div className={styles.robotBadge}>
                <span>기체 식별 LED 장착</span>
                <span>비상정지 버튼</span>
                <span>터치 스크린 인터페이스</span>
                <span>오픈형&덤프형 적재함</span>
                <span>대용량 물류 배송 서비스</span>
            </div>
        </div>
    )
}
